import { useQuery } from '@tanstack/react-query';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import type { EmailAttachment } from '~/routes/_dashboard/mailbox/-components/types';
import { EmailFrame } from '~/routes/_dashboard/mailbox/-components/email-html-body';
import { useTRPC } from '~/lib/trpc';

const NO_ATTACHMENTS: Array<EmailAttachment> = [];

/**
 * What the receptionist did not write but the recipient will read.
 *
 * Silent on a deployment with no footer configured, so the line is never a
 * claim about something that will not be added.
 */
export function EmailFooterNotice() {
  const { t } = useTranslation('mailbox');
  const trpc = useTRPC();
  const [isShown, setIsShown] = React.useState(false);
  const { data: footer } = useQuery(
    trpc.emails.footerSettings.getEmailFooter.queryOptions(),
  );

  if (!footer) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2 pt-2">
      <p className="text-xs text-muted-foreground">
        {t('The clinic footer will be added')}{' '}
        <button
          type="button"
          onClick={() => setIsShown((shown) => !shown)}
          className="cursor-pointer underline decoration-dotted underline-offset-2"
        >
          {isShown ? t('Hide') : t('Show')}
        </button>
      </p>
      {isShown && (
        <EmailFrame
          title={t('Clinic footer')}
          htmlContent={footer}
          textContent=""
          attachments={NO_ATTACHMENTS}
        />
      )}
    </div>
  );
}
